var $0f592d681121713f$exports = {};
// selecting elements
const $0f592d681121713f$var$body = document.querySelector("body");
const $0f592d681121713f$var$btn = document.querySelector("#btn");
const $0f592d681121713f$var$title = document.querySelector(".title");
const $0f592d681121713f$var$allText = document.querySelectorAll("*");
const $0f592d681121713f$var$navLinks = document.querySelectorAll("nav a");
const $0f592d681121713f$var$featureCards = document.querySelectorAll(".feature-card");
const $0f592d681121713f$var$galleryItems = document.querySelectorAll(".gallery-item");
const $0f592d681121713f$var$form = document.querySelector(".contact-form");
// Define random color Generator function
function $0f592d681121713f$var$randomColorGen() {
    const r = Math.round(Math.random() * 255);
    const g = Math.round(Math.random() * 255);
    const b = Math.round(Math.random() * 255);
    return `rgb(${r}, ${g}, ${b})`;
}
// Change colors for all elements
$0f592d681121713f$var$btn.addEventListener("click", ()=>{
    // Change background color of body and container
    // container.style.backgroundColor = randomColorGen();
    // body.style.background = `linear-gradient(135deg, ${randomColorGen()}, ${randomColorGen()}, ${randomColorGen()})`
    // Change text color of all elements
    $0f592d681121713f$var$allText.forEach((el)=>{
        el.style.color = $0f592d681121713f$var$randomColorGen();
    });
    // Change button colors
    $0f592d681121713f$var$btn.style.backgroundColor = $0f592d681121713f$var$randomColorGen();
    $0f592d681121713f$var$btn.style.color = $0f592d681121713f$var$randomColorGen();
    // Change specific element colors
    $0f592d681121713f$var$title.style.color = $0f592d681121713f$var$randomColorGen();
    // Change nav link colors
    $0f592d681121713f$var$navLinks.forEach((link)=>{
        link.style.backgroundColor = $0f592d681121713f$var$randomColorGen();
    });
    // Change feature card colors
    $0f592d681121713f$var$featureCards.forEach((card)=>{
        card.style.backgroundColor = $0f592d681121713f$var$randomColorGen();
    });
    // Change gallery item colors
    $0f592d681121713f$var$galleryItems.forEach((item)=>{
        item.style.backgroundColor = $0f592d681121713f$var$randomColorGen();
    });
    // Change form colors
    $0f592d681121713f$var$form.style.backgroundColor = $0f592d681121713f$var$randomColorGen();
});


//# sourceMappingURL=path0.7a939050.js.map
